<template>
  <div class="login">
    <div class="sidebar">
      <div class="flex">
        <img class="h-20 mr-4" src="~@/assets/img/logo.svg" />
        <div class="brand">
          <div class="title">PandaVue</div>
          <div class="subtitle">WWF-Australia</div>
        </div>
      </div>
      <div v-if="error">
        <Alert :message="error"></Alert>
        <div class="link" v-on:click="navigateTo('forgot-password')">Back to Forgot Password →</div>
      </div>
      <form @submit.prevent="resetPassword" v-if="!error">
        <Alert :message="message"></Alert>
        <div class="field" v-if="!success">
          <label>New Password</label>
          <input required v-model="password" type="password" />
        </div>
        <div class="field" v-if="!success">
          <label>Password Confirmation</label>
          <input required v-model="password2" type="password" />
        </div>
        <button
          class="primary"
          type="submit"
          :class="[loading === 1 ? 'load' : loading === 2 ? 'ok' : null]"
          v-if="!success"
        >
          Update Password
        </button>
        <div class="link" v-on:click="navigateTo('/login')">Back to Login →</div>
      </form>
      <div class="footer"></div>
    </div>
    <div class="image bg-local" :style="{ 'background-image': 'url(\'' + image + '\')' }"></div>
  </div>
</template>

<script>
import Alert from '../components/Alert.vue';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'ResetPassword',
  components: {
    Alert,
  },
  data() {
    return {
      image: require(`@/assets/img/background.jpg`),
      password: '',
      password2: '',
      loading: 0,
      message: undefined,
      success: false,
      error: undefined,
      mode: null,
      oobCode: null,
      apiKey: null,
    };
  },
  beforeMount() {
    this.mode = this.$route.query.mode;
    this.oobCode = this.$route.query.oobCode;
    this.apiKey = this.$route.query.apiKey;

    if (!this.mode || !this.oobCode || !this.apiKey) {
      this.error = {
        content: "Invalid parameters, please follow the 'Forgot Password' procedure. ",
        type: 'error',
      };
    }

    firebase
      .auth()
      .verifyPasswordResetCode(this.oobCode)
      .catch(() => {
        this.error = {
          content: "Expired token, please follow the 'Forgot Password' procedure. ",
          type: 'error',
        };
      });
  },
  methods: {
    resetPassword: function () {
      this.loading = 1;
      this.message = null;

      const password = this.password;
      const password2 = this.password2;

      if (password.length < 8) {
        this.success = false;
        this.loading = 0;
        this.message = {
          content: 'Password must be at least 8 characters',
          type: 'error',
        };
        return;
      }

      if (password !== password2) {
        this.success = false;
        this.loading = 0;
        this.message = {
          content: 'Passwords do not match.',
          type: 'error',
        };
        return;
      }

      firebase
        .auth()
        .confirmPasswordReset(this.oobCode, password)
        .then(() => {
          this.success = true;
          this.loading = 0;
          this.message = {
            content: 'Your password has been updated successfully.',
            type: 'success',
          };
        })
        .catch((err) => {
          this.success = false;
          this.loading = 0;
          this.message = {
            content: err.code,
            type: 'error',
          };
        });
    },
    navigateTo: function (url) {
      if (this.$route.path !== url) {
        this.$router.push({ path: url });
      }
    },
  },
};
</script>

<style scoped>
.login {
  @apply flex h-screen w-full;
}

.sidebar {
  @apply flex flex-col justify-between items-start w-96 p-6 bg-gray-50;
}

button {
  @apply mt-4;
}

.link {
  @apply text-gray-600 cursor-pointer;
}

.image {
  @apply hidden md:flex-1 md:flex items-center justify-center bg-white bg-cover;
}

.brand {
  @apply flex flex-col justify-center;
}

.brand .title {
  @apply text-xl font-bold;
}

.brand .subtitle {
  @apply text-xs;
}
</style>
